<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import HeaderViewOld from "./Old/TrashViewOld.vue";
import NewHeaderView from "./New/NewTrashView.vue";

const current = useUiWrapper(HeaderViewOld, NewHeaderView);
</script>
